import AddBox from "@material-ui/icons/AddBox";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import Check from "@material-ui/icons/Check";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Edit from "@material-ui/icons/Edit";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Remove from "@material-ui/icons/Remove";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Search from "@material-ui/icons/Search";
import ViewColumn from "@material-ui/icons/ViewColumn";
import React from "react";

export const calendar = {
  DATE_FORMAT: "YYYY-MM-DD",
};

export const moment = {
  format: "ddd, MMM Do YYYY, HH:mm z",
};

export const officerLevels = {
  LEVEL_1: {
    text: "Level 1",
    value: "LEVEL_1",
  },
  LEVEL_2: {
    text: "Level 2",
    value: "LEVEL_2",
  },
  LEVEL_3: {
    text: "Level 3",
    value: "LEVEL_3",
  },
  NULL: {
    text: "None",
    value: "NULL",
  },
};
export const missingValue = "";

export const mixpanel = {
  ADMIN_CREATE_CLIENT: "Admin - Create Client",
  ADMIN_APPROVE_REPORTS: "Admin - Approve Reports",
  ADMIN_RESTORE_USER: "Admin - Restore User",
  ADMIN_CREATE_PROPERTY: "Admin - Create Property",
  ADMIN_CREATE_USER: "Admin - Create User",
  ADMIN_DELETE_USER: "Admin - Delete User",
  ADMIN_RESEND_TEMPORARY_PASSWORD: "Admin - Resend Temporary Password",
  ADMIN_UPGRADE_PROPERTY: "Admin - Upgrade Property",
  INCIDENT_REPORT_UPDATE: "Incident Report - Update",
  INCIDENT_REPORT_SUBMIT: "Incident Report - Submit",
  INCIDENT_REPORT_EDIT: "Incident Report - Edit",
  DIVISION_CREATE: "Division - Create",
  DIVISION_UPDATE: "Division - Update",
  DIVISION_DELETE: "Division - Delete",
  DIVISION_RELATION_CREATE: "Division Relation - Create",
  DIVISION_RELATION_DELETE: "Division Relation - Delete",
  DIVISION_RELATION_BATCH_WRITE: "Division Relation - Batch write",
  LOCATION_REQUEST_RESPONSE: "Location - Request Response",
  LOCATION_RESOLVE_RESPONSE: "Location - Resolve Response",
  LOCATION_SEND_MESSAGE: "Location - Send Message",
  LOCATION_UPDATE: "Location - Update",
  LOCATION_VIEW_MESSAGES: "Location - View Messages",
  MAP_LOCATE_RESPONSES: "Map - Locate Responses",
  PATROL_CREATE: "Patrol - Create",
  PATROL_EDIT: "Patrol - Edit",
  SCHEDULING_CREATE_TEMPATE: "Scheduling - Create Template",
  SCHEDULING_UPDATE_TEMPATE: "Scheduling - Update Template",
  SCHEDULING_DELETE_TEMPATE: "Scheduling - Delete Template",
  SCHEDULING_APPROVE_COVERAGE: "Scheduling - Approve Coverage",
  SCHEDULING_DENY_COVERAGE: "Scheduling - Deny Coverage",
  SCHEDULING_SEND_REMINDERS: "Scheduling - Send Reminders",
  SCHEDULING_CREATE_OPEN_SHIFT: "Scheduling - Create Open Shift",
  SCHEDULING_ACKNOWLEDGE_SHIFT: "Scheduling - Acknowledge Shift",
  SCHEDULING_CREATE_SHIFT: "Scheduling - Create Shift",
  SCHEDULING_DELETE_SHIFT: "Scheduling - Delete Shift",
  SCHEDULING_PUBLISH_SHIFTS: "Scheduling - Publish Shifts",
  SCHEDULING_REQUEST_COVERAGE: "Scheduling - Request Coverage",
  SCHEDULING_REQUEST_SHIFT: "Scheduling - Request Shift",
  SCHEDULING_REQUEST_TIME_OFF: "Scheduling - Request Time Off",
  SCHEDULING_UPDATE_SHIFT: "Scheduling - Update Shift",
  SCHEDULING_DENY_TIME_OFF: "Scheduling - Deny Time Off",
  SCHEDULING_APPROVE_TIME_OFF: "Scheduling - Approve Time Off",
  SCHEDULING_COMPLETE_POST_ORDER: "Scheduling - Complete Post Order",
  SCHEDULING_UNDO_POST_ORDER_COMPLETION:
    "Scheduling - Undo Post Order Completion",
  SCHEDULING_ADD_POST_ORDER: "Scheduling - Add Post Order",
  SCHEDULING_DELETE_POST_ORDER: "Scheduling - Delete Post Order",
  SCHEDULING_EDIT_POST_ORDER: "Scheduling - Edit Post Order",
  USER_UPDATE: "User - Update",
};

export const timezones = {
  US_EASTERN: "US/Eastern",
  US_CENTRAL: "US/Central",
  US_MOUNTAIN: "US/Mountain",
  US_ARIZONA: "US/Arizona",
  US_PACIFIC: "US/Pacific",
  US_ALASKA: "US/Alaska",
  US_HAWAII: "US/Hawaii",
};

export const shift = {
  status: {
    created: {
      text: "Draft",
      value: "CREATED",
    },
    published: {
      text: "Published",
      value: "PUBLISHED",
    },
    acknowledged: {
      text: "Acknowledged",
      value: "ACKNOWLEDGED",
    },
    timeOffRequested: {
      text: "Time off requested",
      value: "TIME_OFF_REQUESTED",
    },
    timeOffApproved: {
      text: "Time off approved",
      value: "TIME_OFF_APPROVED",
    },
    coverageRequested: {
      text: "Coverage requested",
      value: "COVERAGE_REQUESTED",
    },
    coverageApproved: {
      text: "Coverage approved",
      value: "COVERAGE_APPROVED",
    },
  },
  statusValueLookup: {
    CREATED: {
      text: "Draft",
    },
    PUBLISHED: {
      text: "Published",
    },
    ACKNOWLEDGED: {
      text: "Acknowledged",
    },
    TIME_OFF_REQUESTED: {
      text: "Time off requested",
    },
    TIME_OFF_APPROVED: {
      text: "Time off approved",
    },
    COVERAGE_REQUESTED: {
      text: "Coverage requested",
    },
    COVERAGE_APPROVED: {
      text: "Coverage approved",
    },
  },
};

export const filter = {
  activeState: {
    ACTIVE: "ACTIVE",
    ARCHIVED: "ARCHIVED",
  },
};

export const recordNames = {
  NAVIGATION: "NAVIGATION",
  NETWORK_REQUEST: "NETWORK_REQUEST",
};

export const property = {
  variant: {
    NONE: {
      text: "None",
      value: "NONE",
    },
    COMMERCIAL: {
      text: "Commercial",
      value: "COMMERCIAL",
    },
    RESIDENTIAL: {
      text: "Residential",
      value: "RESIDENTIAL",
    },
    TECHNOLOGIES: {
      text: "Technologies",
      value: "TECHNOLOGIES",
    },
  },
  variantText: {
    COMMERCIAL: "Commercial",
    RESIDENTIAL: "Residential",
    NONE: "None",
  },
  variantInputs: {
    COMMERCIAL: {
      text: "Commercial",
      value: "COMMERCIAL",
    },
    RESIDENTIAL: {
      text: "Residential",
      value: "RESIDENTIAL",
    },
    TECHNOLOGIES: {
      text: "Technologies",
      value: "TECHNOLOGIES",
    },
  },
};

export const helpText = {
  shiftTemplate: "Selecting a shift template will auto-fill fields for you.",
  propertyDivisionAdd:
    "By selecting a division, every user within that division will have access to the property. If a property is not in a division, users in that division will not have access to the property. At least 1 division is required.",
  propertyDivisionSelection: "Select at least one division (click to toggle).",
  propertyGeofence:
    "The property geofence is used to force officers to physically be within the bounds of a property when doing a daily activity report, it is also used when doing a response to let everyone know when the responding officer has arrived.",
  propertyVariant:
    "The property variant is used to organize your properties into Commercial and Residential. Used for filtering only.",
  propertyDisplayName:
    "The property display name is used to identify your properties. Think of it as a more easily memorable alternative to the address.",
  propertyAddressSearch:
    "Enter in the property address. Kirs will try to find the coordinates, timezone, and address components.",
  propertySubpremise: "Suite, apartment, or building number/letter.",
  propertyAdminNote:
    "The admin note can only be seen by users with either Admin or Dispatch roles. The admin note is commonly used to store more sensitive information about properties.",
  propertyServiceProviderNote:
    "The general note can be seen by everyone in your company.",
  patrolWindowExplanation: `Patrol windows define when a property needs to be patrolled and repeat every day. Skip this step if you don't need patrol windows.`,
  patrolWindowRequiredDars:
    "The number of daily activity reports you would like to be created during the patrol window.",
  patrolWindowStartTime: "The start of the patrol window.",
  patrolWindowEndTime: "The end of the patrol window.",
  userRole:
    "The role defines the permission level of the users. Admins have unlimited access to Kirs. Dispatch cannot create or delete properties and users. Officers only have access to the Kirs Officer mobile app.",
  userDisplayName: "The full name of the user.",
  userEmail: "The email that the user will use to login with.",
  userDivisionAdd:
    "By selecting a division, every property in that division will be visible to the user. If a user is not in a division, properties in that division will not be visible to the user. At least 1 division is required.",
  userDivisionSelection: "Select at least one division (click to toggle).",
  adminOnlyAction: "You do not have permission to perform this action.",
  adminOnlyEdit: "You do not have permission to edit this content.",
  readOnly: "This information is read-only.",
};

export const errors = {
  noDivisionsOnProperty: "Please select at least one division.",
  noDivisionsOnUser: "Please select at least one division.",
};

export const user = {
  status: {
    OFFLINE: "OFFLINE",
    WALKING: "WALKING",
    DRIVING: "DRIVING",
    RUNNING: "RUNNING",
    STILL: "STILL",
    ONLINE: "ONLINE",
  },
  statusText: {
    OFFLINE: "Offline",
    WALKING: "Walking",
    DRIVING: "Driving",
    RUNNING: "Running",
    STILL: "Still",
    ONLINE: "Online",
  },
  levelText: {
    LEVEL_1: "Level 1",
    LEVEL_2: "Level 2",
    LEVEL_3: "Level 3",
  },
  list: {
    AVAILABLE: "Available",
    UNAVAILABLE: "Unavailable",
    OFFLINE: "Offline",
  },
  roleText: {
    ADMIN: "Admin",
    OFFICER: "Officer",
    DISPATCH: "Dispatch",
    SUPERVISOR: "Supervisor",
  },
  role: {
    admin: {
      text: "Admin",
      value: "ADMIN",
    },
    officer: {
      text: "Officer",
      value: "OFFICER",
    },
    dispatch: {
      text: "Dispatch",
      value: "DISPATCH",
    },
  },
};

export const map = {
  selected: {
    PROPERTY: "PROPERTY",
    USER: "USER",
  },
};

export const patrolViewMode = {
  recent: "RECENT",
  filtered: "FILTERED",
};

export const directions = {
  status: {
    ok: {
      name: "OK",
    },
    notFound: {
      name: "NOT_FOUND",
      error: `One of the locations specified in the request's origin, destination, or waypoints could not be geocoded.`,
    },
    zeroResults: {
      name: "ZERO_RESULTS",
      error: `No route could be found between the origin and destination.`,
    },
    maxWaypointsExceeded: {
      name: "MAX_WAYPOINTS_EXCEEDED",
      error: `Too many waypoints were provided in the request.`,
    },
    maxRouteLengthExceeded: {
      name: "MAX_ROUTE_LENGTH_EXCEEDED",
      error: `The requested route is too long and cannot be processed.`,
    },
    invalidRequest: {
      name: "INVALID_REQUEST",
      error: `The provided request was invalid.`,
    },
    overDailyLimit: {
      name: "OVER_DAILY_LIMIT",
      error: `Usage cap has been exceeded. Try again tomorrow.`,
    },
    overQueryLimit: {
      name: "OVER_QUERY_LIMIT",
      error: `Over limit. Try again in a bit.`,
    },
    requestDenied: {
      name: "REQUEST_DENIED",
      error: `The service denied use of the directions service.`,
    },
    unknownError: {
      name: "UNKNOWN_ERROR",
      error: `Unknown error. Try again in a bit.`,
    },
  },
};

export const subject = {
  ethnicity: {
    hispanicLatino: {
      text: "Hispanic/Latino",
      value: "HISPANIC",
    },
    nonHispanicLatino: {
      text: "Non-Hispanic/Latino",
      value: "NON_HISPANIC",
    },
    unknown: {
      text: "Unknown",
      value: "UNKNOWN",
    },
    null: {
      text: missingValue,
      value: null,
    },
  },
  eyeColor: {
    brown: {
      text: "Brown",
      value: "BROWN",
    },
    blue: {
      text: "Blue",
      value: "BLUE",
    },
    green: {
      text: "Green",
      value: "GREEN",
    },
    other: {
      text: "Other",
      value: "OTHER",
    },
    null: {
      text: missingValue,
      value: null,
    },
  },
  hairColor: {
    bald: {
      text: "Bald",
      value: "BALD",
    },
    black: {
      text: "Black",
      value: "BLACK",
    },
    blonde: {
      text: "Blonde",
      value: "BLONDE",
    },
    brown: {
      text: "Brown",
      value: "BROWN",
    },
    grey: {
      text: "Grey",
      value: "GREY",
    },
    red: {
      text: "Red",
      value: "RED",
    },
    other: {
      text: "Other",
      value: "OTHER",
    },
    null: {
      text: missingValue,
      value: null,
    },
  },
  race: {
    white: {
      text: "White",
      value: "WHITE",
    },
    black: {
      text: "Black",
      value: "BLACK",
    },
    asian: {
      text: "Asian",
      value: "ASIAN",
    },
    nativeAmerican: {
      text: "Native American",
      value: "NATIVE_AMERICAN",
    },
    unknown: {
      text: "Unknown",
      value: "UNKNOWN",
    },
    null: {
      text: missingValue,
      value: null,
    },
  },
  sex: {
    male: {
      text: "Male",
      value: "MALE",
    },
    female: {
      text: "Female",
      value: "FEMALE",
    },
    other: {
      text: "Other",
      value: "OTHER",
    },
    null: {
      text: missingValue,
      value: null,
    },
  },
  type: {
    deceased: {
      text: "Deceased",
      value: "DECEASED",
    },
    interviewed: {
      text: "Interviewed",
      value: "INTERVIEWED",
    },
    missingRunaway: {
      text: "Missing/Runaway",
      value: "MISSING_RUNAWAY",
    },
    parentGuardian: {
      text: "Parent/Guardian",
      value: "PARENT_GUARDIAN",
    },
    reportingPerson: {
      text: "Reporting person",
      value: "REPORTING_PERSON",
    },
    victim: {
      text: "Victim",
      value: "VICTIM",
    },
    witness: {
      text: "Witness",
      value: "WITNESS",
    },
    other: {
      text: "Other",
      value: "OTHER",
    },
    null: {
      text: missingValue,
      value: null,
    },
  },
};

export const states = {
  alabama: {
    text: "Alabama",
    abbreviation: "AL",
  },
  alaska: {
    text: "Alaska",
    abbreviation: "AK",
  },
  arizona: {
    text: "Arizona",
    abbreviation: "AZ",
  },
  arkansas: {
    text: "Arkansas",
    abbreviation: "AR",
  },
  california: {
    text: "California",
    abbreviation: "CA",
  },
  colorado: {
    text: "Colorado",
    abbreviation: "CO",
  },
  connecticut: {
    text: "Connecticut",
    abbreviation: "CT",
  },
  delaware: {
    text: "Delaware",
    abbreviation: "DE",
  },
  districtOfColumbia: {
    text: "District of Columbia",
    abbreviation: "DC",
  },
  florida: {
    text: "Florida",
    abbreviation: "FL",
  },
  georgia: {
    text: "Georgia",
    abbreviation: "GA",
  },
  hawaii: {
    text: "Hawaii",
    abbreviation: "HI",
  },
  idaho: {
    text: "Idaho",
    abbreviation: "ID",
  },
  illinois: {
    text: "Illinois",
    abbreviation: "IL",
  },
  indiana: {
    text: "Indiana",
    abbreviation: "IN",
  },
  iowa: {
    text: "Iowa",
    abbreviation: "IA",
  },
  kansas: {
    text: "Kansas",
    abbreviation: "KS",
  },
  kentucky: {
    text: "Kentucky",
    abbreviation: "KY",
  },
  louisiana: {
    text: "Louisana",
    abbreviation: "LA",
  },
  maine: {
    text: "Maine",
    abbreviation: "ME",
  },
  maryland: {
    text: "Maryland",
    abbreviation: "MD",
  },
  massachusetts: {
    text: "Massachusetts",
    abbreviation: "MA",
  },
  michigan: {
    text: "Michigan",
    abbreviation: "MI",
  },
  minnesota: {
    text: "Minnesota",
    abbreviation: "MN",
  },
  mississippi: {
    text: "Mississippi",
    abbreviation: "MS",
  },
  missouri: {
    text: "Missouri",
    abbreviation: "MO",
  },
  montana: {
    text: "Montana",
    abbreviation: "MT",
  },
  nebraska: {
    text: "Nebraska",
    abbreviation: "NE",
  },
  nevada: {
    text: "Nevada",
    abbreviation: "NV",
  },
  newHampshire: {
    text: "New Hampshire",
    abbreviation: "NH",
  },
  newJersey: {
    text: "New Jersey",
    abbreviation: "NJ",
  },
  newMexico: {
    text: "New Mexico",
    abbreviation: "NM",
  },
  newYork: {
    text: "New York",
    abbreviation: "NY",
  },
  northCarolina: {
    text: "North Carolina",
    abbreviation: "NC",
  },
  northDakota: {
    text: "North Dakota",
    abbreviation: "ND",
  },
  ohio: {
    text: "Ohio",
    abbreviation: "OH",
  },
  oklahoma: {
    text: "Oklahoma",
    abbreviation: "OK",
  },
  oregon: {
    text: "Oregon",
    abbreviation: "OR",
  },
  pennsylvania: {
    text: "Pennsylvania",
    abbreviation: "PA",
  },
  rhodeIsland: {
    text: "Rhode Island",
    abbreviation: "RI",
  },
  southCarolina: {
    text: "South Carolina",
    abbreviation: "SC",
  },
  southDakota: {
    text: "South Dakota",
    abbreviation: "SD",
  },
  tennessee: {
    text: "Tennessee",
    abbreviation: "TN",
  },
  texas: {
    text: "Texas",
    abbreviation: "TX",
  },
  utah: {
    text: "Utah",
    abbreviation: "UT",
  },
  vermont: {
    text: "Vermont",
    abbreviation: "VT",
  },
  virginia: {
    text: "Virginia",
    abbreviation: "VA",
  },
  washington: {
    text: "Washington",
    abbreviation: "WA",
  },
  westVirginia: {
    text: "West Virginia",
    abbreviation: "WV",
  },
  wisconsin: {
    text: "Wisconsin",
    abbreviation: "WI",
  },
  wyoming: {
    text: "Wyoming",
    abbreviation: "WY",
  },
  null: {
    text: missingValue,
    value: null,
  },
};

export const vehicle = {
  status: {
    abandoned: {
      text: "Abandoned",
      value: "ABANDONED",
    },
    burned: {
      text: "Burned",
      value: "BURNED",
    },
    damagedVandalized: {
      text: "Damaged/Vandalized",
      value: "DAMAGED_VANDALIZED",
    },
    rec: {
      text: "Reclaimed",
      value: "RECLAIMED",
    },
    repossessed: {
      text: "Repossessed",
      value: "REPOSSESSED",
    },
    seized: {
      text: "Seized",
      value: "SEIZED",
    },
    stolen: {
      text: "Stolen",
      value: "STOLEN",
    },
    suspectVehicle: {
      text: "Suspect vehicle",
      value: "SUSPECT_VEHICLE",
    },
    victimVehicle: {
      text: "Victim vehicle",
      value: "VICTIM_VEHICLE",
    },
    other: {
      text: "Other",
      value: "OTHER",
    },
    null: {
      text: missingValue,
      value: null,
    },
  },
  type: {
    airplane: {
      text: "Airplane",
      value: "AIRPLANE",
    },
    automobile: {
      text: "Automobile",
      value: "AUTOMOBILE",
    },
    bus: {
      text: "Bus",
      value: "BUS",
    },
    motorHome: {
      text: "Motor home",
      value: "MOTOR_HOME",
    },
    truck: {
      text: "Truck",
      value: "TRUCK",
    },
    other: {
      text: "Other",
      value: "OTHER",
    },
    null: {
      text: missingValue,
      value: null,
    },
  },
  null: {
    text: missingValue,
    value: null,
  },
  other: {
    text: "Other",
    value: "OTHER",
  },
  unknown: {
    text: "Unknown",
    value: "UNKNOWN",
  },
};

export const materialTable = {
  tableIcons: {
    Add: React.forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: React.forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: React.forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: React.forwardRef((props, ref) => (
      <DeleteOutline {...props} ref={ref} />
    )),
    DetailPanel: React.forwardRef((props, ref) => (
      <ChevronRight {...props} ref={ref} />
    )),
    Edit: React.forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: React.forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: React.forwardRef((props, ref) => (
      <FilterList {...props} ref={ref} />
    )),
    FirstPage: React.forwardRef((props, ref) => (
      <FirstPage {...props} ref={ref} />
    )),
    LastPage: React.forwardRef((props, ref) => (
      <LastPage {...props} ref={ref} />
    )),
    NextPage: React.forwardRef((props, ref) => (
      <ChevronRight {...props} ref={ref} />
    )),
    PreviousPage: React.forwardRef((props, ref) => (
      <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: React.forwardRef((props, ref) => (
      <Clear {...props} ref={ref} />
    )),
    Search: React.forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: React.forwardRef((props, ref) => (
      <ArrowUpward {...props} ref={ref} />
    )),
    ThirdStateCheck: React.forwardRef((props, ref) => (
      <Remove {...props} ref={ref} />
    )),
    ViewColumn: React.forwardRef((props, ref) => (
      <ViewColumn {...props} ref={ref} />
    )),
  },
};
